module.exports = __webpack_public_path__ + "static/media/tinyPhone.1799c8a4.svg";